<template>
	<div class="px-5 pt-3 pb-2 mb-5 ResponsiveAudit page-fill">
		<div class="items-center justify-between flex">
			<div class="title flex items-center">
				<h1>CAPA Tasks</h1>
			</div>
			<div class="flex items-center">
				
				<button class="flex" @click="filterOpen" :class="tableRow.length == 0 ? 'btndisabled pointer-events-none' : 'filterButton'">
					<img v-if="tableRow.length == 0" src="@/assets/filterIcon_Disabled.svg" class="filterIcon"/>
					<img v-else src="@/assets/filter.svg" class="filterIcon" />
					Filters
				</button>
			</div>
		</div>
		<div class="mt-3">
			<p class="headerText">
Manage Corrective and Preventive Action (CAPA) tasks linked to Audit findings. Create, assign, and track tasks to ensure timely resolution, prevent recurrence, and strengthen your organization’s overall compliance and risk posture.			</p>
		</div>
		<div class="table-section">
			<tableData class="flex-1 min-h-0" :tableRowData="tableRow" :headersData="headersTable" :loadData="dataLoading"></tableData>
			<div v-if="toolTipActive">
				<tool-tip :tipText="toolTipText"></tool-tip>
			</div>
		</div>
	</div>
</template>
<style scoped>
/* .btnPrimaryPadding{
	padding-left : 16px;
	padding-right : 16px;
} */
</style>
<script lang="ts">
import { defineComponent } from 'vue';
import _ from 'lodash';
import { required } from '@vuelidate/validators';
import tableData from '@/components/tableData.vue';
import useVuelidate from '@vuelidate/core';
import { mapGetters } from 'vuex';
import { emitter, toast } from '@/main';
import toolTip from '@/components/toolTip.vue'
import moment from 'moment';

export default defineComponent({
	data(): any {
		return { 
			v$: useVuelidate(),
			savedFindingSets: [],
			optionsUserArray: [],
			showFilters: false,
			dummyList: [],
			tableRow: [],
			optionUserArray:[],
            allTasks:[],
			teamObject:[],
			presentFindingTaskObj:{},
			users : [],
			headersTable:['taskId','action','department','location','assignee','dueDate','statusCode'],
			toolTipActive:false,
			toolTipText:'',
			dataLoading:true,
			orgUsersList:[]
		};
	},
	components: {
		tableData,
		toolTip
	},
	computed: {
		...mapGetters({ userInfo: 'userInfo' }),
	},
	
	methods: {
		async getAllTeams() {
            this.teamObject = []
            // let users:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/departments/get`).then((res: any) => {
                this.users = res.data;
                this.teamsData = res.data;
            });
            for (var i = 0; i < this.users.length; i++) {
                this.teamObject.push({ label: this.users[i].displayName, value: this.users[i]._id });
            }
        },
		getTeamName(team: any) {
            let teamObj = this.users.find((obj: any) => {
                return obj._id == team;
            });
            if (teamObj == undefined) {
                return 'N/A';
            } else {
                return teamObj.displayName;
            }
        },
		 async getallEntities() {
            this.locationObject = []
			let result:any
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`).then((res: any) => {
                result = res.data;
            });
            for (var i = 0; i < result.length; i++) {
                this.locationObject.push({ label: result[i].entityDisplayName, value: result[i]._id,entityType:result[i].entityType });
            }
        },
		getLocationName(teamId: any) {
			let teamObj = this.users.find((obj: any) => {
                return obj._id == teamId;
            });
            if (teamObj == undefined) {
                return 'N/A';
            } else if(teamObj.entityType != undefined && teamObj.entityType == 20301) {
                return 'Global'
            }else if(teamObj.entityType != undefined && teamObj.entityType == 20303){
				return teamObj.entityName? teamObj.entityDisplayName:'N/A'
			}else{
				return 'N/A';
			}
        },
		async getAllActiveUsers() {
            await this.$http.get(`${process.env.VUE_APP_ORG_API}/users/active/getall`).then((res: any) => {
                this.orgUsersList = res.data;
                this.allOrgUsers = this.orgUsersList
                // this.orgUsersList = this.orgUsersList.filter((user: any) => {
                //     return user.isActive == true;
                // });
                for (var i = 0; i < this.orgUsersList.length; i++) {
                    this.optionsUserArray.push({ label: this.orgUsersList[i].name, value: this.orgUsersList[i]._id });
					// if(this.userInfo._id != this.orgUsersList[i]._id){
					// }
                }
            });
        },
		async getAllFindingTasks(){
			this.tableRow = []
            await this.$http
				.get(`${process.env.VUE_APP_AUDIT_API}/api/capa-tasks/getall`)
				.then((result: any) => {

                this.allTasks = result.data || [];
				   
                   this.allTasks.forEach((task:any) => {
							let locationName:any = 'N/A';
							let keysOfObject:any = Object.keys(task)
							let departmentName:any  = task.department != undefined ? this.getTeamName(task.department) : 'N/A';
							if(keysOfObject.includes('location') && task.location!=undefined && task.location!='global') {								
								locationName = this.locationObject.find((l:any)=>l.value.toString()==task.location.toString())?.label || 'N/A';
							}
							else if(keysOfObject.includes('location') && task.location=='global'){
								locationName = this.locationObject.find((l:any)=>l.entityType==1)?.label||'N/A'
							}
							if(task.assignee && task.assignee!=undefined){
								let assignee = this.optionsUserArray.find((user:any)=>user.value==task.assignee);	
								if(assignee && assignee!=undefined){
									task.assignee = assignee.label
								}
								else{
									task.assignee='N/A'
								}
							}
							if(task.dueDate==undefined){
								task.dueDate='N/A'
							}
							else{
								task.dueDate = moment(task.dueDate).format('DD-MM-YYYY')
							}
							task.taskId = task.taskId != undefined ? task.taskId : 'N/A'
							task.action = task.action != undefined ? task.action : 'N/A'
							task.assignee = task.assignee != undefined ? task.assignee : 'N/A',
							task.statusCode = task.statusCode != undefined ? task.statusCode : 'N/A',
							this.tableRow.push({ ...task,location: locationName ,department: departmentName});
					})
                   
            });
            
        },
		
        isDetailsModalOpen() {
            return !!document.querySelector('.details-modal-overlay');
        },
        bindCapaTableListeners() {
            emitter.off('clickedOnTableRow')
            emitter.on('clickedOnTableRow', this.onCapaTableRowClick)
        },
        async onDetailsModalClosed() {
            this.bindCapaTableListeners();
            const scrollEl = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            const scrollTop = scrollEl?.scrollTop || 0;
            await this.refreshAfterDetailsModal();
            await this.$nextTick();
            const restored = this.$el?.querySelector?.('.table-body-scroll') as HTMLElement | null;
            if (restored) {
                restored.scrollTop = scrollTop;
            }
        },
        onCapaTableRowClick(actionObj:any){
            if(this.isDetailsModalOpen()){
                return;
            }
            this.goToFindingsInfo(actionObj)
        },
        goToFindingsInfo(obj:any){
            emitter.emit('openDetailsModal', {
                view: 'findingTaskEdit',
                title: obj.action || 'CAPA Task',
                params: { findingId: obj.linkedFindingId, taskId: obj._id },
            });
        },
        async refreshAfterDetailsModal() {
            this.dataLoading = true;
            this.tableRow = [];
            await this.getAllFindingTasks();
            this.dataLoading = false;
        },

		filterOpen() {
			this.showFilters = !this.showFilters;
			if (this.showFilters == true) {
                this.dummyList = this.tableRow;
            } else {
                this.tableRow = this.dummyList;
            }
			emitter.emit('visible', this.showFilters);
		},
        
	},
	async created() {

		this.dataLoading = true;

		await this.getAllTeams();
        await this.getallEntities();
		await this.getAllActiveUsers();
        await this.getAllFindingTasks();

		this.dataLoading = false;
		
        this.bindCapaTableListeners();
		emitter.off('detailsModalClosed', this.onDetailsModalClosed)
		emitter.on('detailsModalClosed', this.onDetailsModalClosed)

		emitter.off('activiteToolTip');
        emitter.on('activiteToolTip', (data: any) => {                        
            this.toolTipActive = true;
            this.toolTipText = data.tipText
        });
 
        emitter.off('deActiviteToolTip');
        emitter.on('deActiviteToolTip', (data: any) => {
            this.toolTipActive = false;
            this.toolTipText = ''
        });
		
    },
	beforeUnmount() {
		emitter.off('clickedOnTableRow', this.onCapaTableRowClick)
		emitter.off('detailsModalClosed', this.onDetailsModalClosed)
	},
});
</script>
 